// extracted by mini-css-extract-plugin
export var borderRadius = "_54-4";
export var large = "_54-3";
export var logoContainer = "_54-0";
export var nameLogo = "_54-2";
export var small = "_54-1";